// page-header.component.ts
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
  @Input() title       = '';
  @Input() active_item = '';

  @Input() titleLink?: string | any[]; 
}
